import firebase, { User } from 'firebase';
const auth = () => firebase.auth();

const authStatus = (cb: (user: User) => void) => auth().onAuthStateChanged((user = null) => cb(user));


const signinWithEP = (email:string, password: string) => {
    return auth().signInWithEmailAndPassword(email, password)
}

const logout = async () => {
    await auth().signOut()
    window.location.replace("/")
}


const getCurrentUser = () => auth().currentUser


const AuthService = {
    authStatus,
    getCurrentUser,
    signinWithEP,
    logout
}

export default AuthService;